export default function AddLot({ data }) {
  return (
    <div>
      <h2 className="text-xl text-yellow-200 mb-3">Add Lot</h2>

      <input placeholder="Farmer Name" className="p-2 text-black mb-2 w-full"/>
      <input placeholder="Crop" className="p-2 text-black mb-2 w-full"/>
      <input placeholder="Quantity" className="p-2 text-black mb-2 w-full"/>

      <button className="bg-green-600 px-4 py-2">Submit</button>
    </div>
  );
}